// dream meet (meet.thedreaminc.org) links for the teacher's class Meeting Link.
// The meeting code format is owned by dream-meet (src/meet/code.ts ROOM_ID_PATTERN).
import { publicOrigin } from './liveTranslation';

const ROOM_ID = /^[a-km-z]{3}-[a-km-z]{4}-[a-km-z]{3}$/;

export function dreamMeetOrigin(value) {
    return publicOrigin(value);
}

export function dreamMeetUrl(origin, roomId) {
    if (!origin || typeof roomId !== 'string' || !ROOM_ID.test(roomId)) return null;
    return `${origin}/meet/${roomId}`;
}

export function isDreamMeetLink(origin, link) {
    if (!origin || typeof link !== 'string' || !link) return false;
    try {
        const url = new URL(link);
        const match = /^\/meet\/([^/]+)\/?$/.exec(url.pathname);
        return url.origin === origin && !!match && ROOM_ID.test(match[1]);
    } catch { return false; }
}
